import classnames from 'classnames/bind'
import { useEffect, useRef, useState } from 'react'

// Components
// import { Input } from 'antd'
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

interface IInput {
  className?: string
  wrapperClassName?: string
  onKeyDown?: (e: any) => void
  onKeyPress?: (e: any) => void
  placeholder?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void // Add this line
  value?: string
  autoFocus?: boolean
  type?: string
  hasError?: boolean
  isFieldFocus?: boolean
  onFocus?: () => void
  iconClassName?: string
  disabled?: boolean
  onBlur?: () => void
}

const InputComponent = ({
  className,
  autoFocus,
  onFocus,
  type,
  wrapperClassName,
  onKeyDown,
  onKeyPress,
  placeholder,
  onChange,
  value,
  isFieldFocus,
  iconClassName,
  disabled,
  onBlur,
}: IInput) => {
  const isPasswordType = type === 'password'

  const [currentInputType, setInputType] = useState(type)

  const isPasswordHidden = currentInputType === 'password'

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (autoFocus || isFieldFocus) inputRef.current?.focus()
  }, [autoFocus, isFieldFocus])

  const handleEyeClick = () => {
    if (isPasswordType) {
      if (isPasswordHidden) {
        setInputType('text')
      } else {
        setInputType('password')
      }
    }
  }
  return (
    <div className={cx('input-wrapper', wrapperClassName)}>
      <input
        className={cx('input-wrapper-input', className)}
        onKeyDown={onKeyDown}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        onChange={onChange} // Add this line
        value={value}
        onFocus={onFocus}
        type={currentInputType}
        disabled={disabled}
        onBlur={onBlur}
      />
      {isPasswordType && (
        <div className={cx('input-wrapper-icon', iconClassName)} onClick={handleEyeClick}>
          {isPasswordHidden && <Icon.EyeClose_Wide />}
          {!isPasswordHidden && <Icon.EyeOpen_HollowEyeball />}
        </div>
      )}
    </div>
  )
}

export default InputComponent
